import React, { useRef, useState } from 'react';

import { observer } from 'mobx-react-lite';
import { action } from 'mobx';

import { Campaign } from 'models/Campaign';

import Switch from '@vromo/ui/components/Switch';
import Table from '@vromo/ui/components/Table';
import Button from '@vromo/ui/components/Button';
import WidgetEditor from './WidgetEditor';
import WidgetRow from './components/WidgetRow';
import { qaLabelCampaigns } from './../../../../../../../common-qa-labels/campaigns';
import { Widget } from '@vromo/models';
import { deserialize } from 'serializr';
import styles from './index.style';
import { useTranslation } from 'react-i18next';

interface Props {
    campaign: Campaign;
}

export default observer<Props>(function Widgets({ campaign }) {
    const { t } = useTranslation();
    const editorViewRef = useRef(null);
    const [promoEditorOpen, setPromoEditorOpen] = useState(false);
    const [editingWidget, setEditingWidget] = useState<boolean>(false);
    const [editWidget, setEditWidget] = useState<Widget | null>(null);

    const openEditor = () => {
        setPromoEditorOpen(true);
        setTimeout(() => editorViewRef?.current?.scrollIntoView({ behavior: 'smooth' }), 40);
    };

    const handleEditWidget = (widget: Widget) => {
        const w = deserialize(Widget, widget);

        setEditWidget(w);
        setEditingWidget(true);
        openEditor();
    };

    const handleCloseEditor = () => {
        setPromoEditorOpen(false);
        setEditingWidget(false);
        setEditWidget(null);
    };

    return (
        <div>
            <div>
                <label>{t('widgets.enabled')}</label>
                <Switch
                    testId={qaLabelCampaigns.editModal.enableWidgetBtn}
                    style={styles.switch}
                    checked={campaign.promotion?.enabled}
                    onChange={action((enabled) => (campaign.promotion.enabled = enabled))}
                />
            </div>

            <hr />

            <Table>
                <thead>
                    <tr>
                        <th />
                        <th>{t('widgets.type')}</th>
                        <th>{t('widgets.value')}</th>
                    </tr>
                </thead>
                <tbody data-testid={qaLabelCampaigns.editModal.widgetBodyTable}>
                    {campaign.widgets
                        ? campaign.widgets.map((widget) => (
                              <WidgetRow
                                  key={widget.id}
                                  campaign={campaign}
                                  widget={widget}
                                  handleEditWidget={() => handleEditWidget(widget)}
                                  handleCloseEditor={handleCloseEditor}
                              />
                          ))
                        : null}
                </tbody>
            </Table>
            <div style={styles.buttonContainer}>
                <Button
                    data-testid={qaLabelCampaigns.editModal.addWidgetBtn}
                    primary
                    onClick={() => {
                        setEditingWidget(false);
                        setEditWidget(null);
                        openEditor();
                    }}>
                    {t('widgets.addWidget')}
                </Button>
            </div>
            {promoEditorOpen ? (
                <div ref={editorViewRef}>
                    <WidgetEditor
                        key={editWidget ? editWidget.id : Date.now()}
                        campaign={campaign}
                        close={handleCloseEditor}
                        editWidget={editWidget}
                        editing={editingWidget}
                        setEditing={setEditingWidget}
                    />
                </div>
            ) : null}
        </div>
    );
});
